<template>
  <div class="sidebar col-xl-3 col-lg-4 pl-3">
    <h3>
      <a
        data-toggle="collapse"
        href="#categoryFilterTree"
        role="button"
        aria-expanded="true"
        aria-controls="categoryFilterTree"
      >
        {{ $t('Filter By') }}
        <i class="fa fa-chevron-up"></i>
      </a>
    </h3>

    <div id="categoryFilterTree" class="collapse show">
      <div
        class="block pb-2 pt-1"
        v-for="category in categories"
        :key="category.value"
      >
        <h6 class="text-uppercase mb-1">{{ category.label }}</h6>
        <treeselect
          :multiple="true"
          :flat="true"
          :options="category.children"
          :placeholder="category.label"
          :model-value="modelValue[category.value]"
          @update:model-value="update(category.value, $event)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import Treeselect from 'vue3-treeselect';
import 'vue3-treeselect/dist/vue3-treeselect.css';
import type Category from '../common/Category';

export default defineComponent({
  name: 'CategoryFilter',
  components: { Treeselect },
  props: {
    categories: Array as PropType<Category[]>,
    modelValue: Object as PropType<Record<string, string[]>>,
  },
  emits: ['update:modelValue'],
  methods: {
    update(key: string, value: string[]) {
      this.$emit('update:modelValue', {
        ...this.modelValue,
        [key]: value || [],
      });
    },
  },
});
</script>
